"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var config_action_1 = require("../../../../actions/config_action");
var button_component_1 = require("../../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../../common/drop_down/drop_down_component");
var pop_up_1 = require("../../../../common/modal/pop-up");
var react_paginate_1 = require("../../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../../constants/appConstants");
var route_path_1 = require("../../../../constants/route_path");
var table_data_1 = require("../../../../constants/table_data");
var menu_constants_1 = require("../../../../menuList/menu_constants");
var reports_helper_1 = require("../reports_helper");
var approvals_helper_1 = require("../../approval_management/apprvals/approvals_helper");
var CashDeletionLogs = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var approval_status = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.approval_status; });
    var approval_types = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.approval_types; });
    var _a = React.useState(undefined), dataList = _a[0], setDataList = _a[1];
    var _b = React.useState(''), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = React.useState(1), pageCount = _c[0], setpageCount = _c[1];
    var _d = React.useState(0), totalPageCount = _d[0], setTotalPageCount = _d[1];
    var _e = React.useState(appConstants_1.defaultPageLimit), PageLimit = _e[0], setPageLimit = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var _g = React.useState(false), open = _g[0], setOpen = _g[1];
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var handlePageLimitChange = function (val) {
        setPageLimit(val);
    };
    var refetch = (0, react_query_1.useQuery)(['Fe-Attendance', pageCount], function () {
        var approvaltype = approval_types === null || approval_types === void 0 ? void 0 : approval_types.find(function (type) { return type.label === 'CASH_ENTRY_DELETION'; });
        var approvalStatus = approval_status === null || approval_status === void 0 ? void 0 : approval_status.find(function (type) { return type.label === 'PENDING_LEVEL_ONE'; });
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var queryParam = "page=".concat(currentPage, "&size=").concat(PageLimit ? parseInt(PageLimit.value.toString()) : 50);
        if (approvaltype) {
            queryParam = queryParam + "&type=".concat(approvaltype.id);
        }
        if (approvalStatus) {
            queryParam = queryParam + "&status=".concat(approvalStatus.id);
        }
        (0, approvals_helper_1.cashDeletionApprovalList)(queryParam)
            .then(function (response) {
            var _a, _b;
            var updatedApprovalList = (0, approvals_helper_1.convertCashDeletionApprovalList)(response.result);
            setDataList(updatedApprovalList);
            setErrorMessage('');
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(((_a = response.data) === null || _a === void 0 ? void 0 : _a.count) / pageSize);
            setTotalPageCount(count);
            setTotalCount((_b = response.data) === null || _b === void 0 ? void 0 : _b.count);
        })
            .catch(function (err) {
            setErrorMessage(err.message);
            setDataList([]);
        });
    }).refetch;
    var autogenerateReport = function () {
        var approvaltype = approval_types === null || approval_types === void 0 ? void 0 : approval_types.find(function (type) { return type.label === 'CASH_ENTRY_DELETION'; });
        var approvalStatus = approval_status === null || approval_status === void 0 ? void 0 : approval_status.find(function (type) { return type.label === 'PENDING_LEVEL_ONE'; });
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {};
        if (approvaltype) {
            payload['type'] = approvaltype.id;
        }
        if (approvalStatus) {
            payload['status'] = approvalStatus.id;
        }
        payload['page'] = currentPage;
        payload['size'] = 100;
        (0, reports_helper_1.cashDeletionLogsReport)(payload)
            .then(function (res) {
            if (res.statusCode === 200) {
                if (res.message != 'Success') {
                    react_hot_toast_1.default.error(res.message);
                }
                else {
                    setOpen(true);
                }
            }
            else {
                react_hot_toast_1.default.error(res.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
        });
    };
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.reports,
            subModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subChaildModule: '',
            subGroupModule: ''
        }));
        navigate("/".concat(route_path_1.default.PATHS.reports, "/").concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var FilterHandler = function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    };
    return (React.createElement("div", { className: "fe-wrapper pay  -fe-wrapper" },
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "Cash Deletion Logs")),
            React.createElement(button_component_1.default, { type: "button", buttonName: appConstants_1.reportDownload, endIcon: "icon-import download-icon", color: "yellow-outline", onClickHandler: autogenerateReport, isError: (dataList === null || dataList === void 0 ? void 0 : dataList.length) <= 0 })),
        React.createElement("div", { className: "filter-menu-wrapper" },
            React.createElement("div", { className: "search-filter" }),
            React.createElement("div", { className: "filter-options" },
                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: handlePageLimitChange, value: PageLimit, isDisabled: true }),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler }))),
        React.createElement("div", { className: "unclickablerow custom-pagination-table" },
            React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.CASH_PENDING_APPROVAL_COLUMNS, rows: dataList, errorMessage: errorMessage, pagination: false, className: 'cash-pending-table' }),
            React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: dataList === null || dataList === void 0 ? void 0 : dataList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value })),
        React.createElement(pop_up_1.default, { open: open },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Request Submitted"),
                React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setOpen(false); } }),
                React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))));
};
exports.default = CashDeletionLogs;
